<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">
      Información de seguimiento con respecto a la visita anterior
    </h4>
    <form-group :error="errors.has('hubo-mas-ataques') && submitted">
      <label class="form__label form__label--required">
        8. ¿Se presentaron ataques de depredación desde nuestra última visita?
      </label>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.huboMasAtaques"
          id="si-hubo"
          name="hubo-mas-ataques"
          v-validate="'required'"
          value="Si"
        >
        <label class="form__label" for="si-hubo">Si</label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.huboMasAtaques"
          id="no-hubo"
          name="hubo-mas-ataques"
          v-validate="'required'"
          value="No"
        >
        <label class="form__label" for="no-hubo">No</label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.huboMasAtaques"
          id="no-aplica"
          name="hubo-mas-ataques"
          v-validate="'required'"
          value="No aplica"
        >
        <label class="form__label" for="no-aplica">No aplica</label>
      </div>
    </form-group>

    <div class="identado" v-if="form.huboMasAtaques === 'Si'">
      <form-group :error="errors.has('cantidad-ataques') && submitted">
        <label class="form__label form__label--required">
          8.1. Indique cuántos y comente brevemente los detalles del caso
          (raza, peso, día o noche, fecha, etc)
        </label>
        <div class="radio radio--azul">
          <input
            :disabled="!editando"
            type="radio"
            v-model="form.cantidadAtaques"
            id="1caso"
            name="cantidad-ataques"
            v-validate="'required'"
            value="1 caso/evento"
          >
          <label class="form__label" for="1caso">1 caso/evento</label>
        </div>
        <div class="radio radio--azul">
          <input
            :disabled="!editando"
            type="radio"
            v-model="form.cantidadAtaques"
            id="2casos"
            name="cantidad-ataques"
            v-validate="'required'"
            value="2 casos/eventos"
          >
          <label class="form__label" for="2casos">2 casos/eventos</label>
        </div>
        <div class="radio radio--azul">
          <input
            :disabled="!editando"
            type="radio"
            v-model="form.cantidadAtaques"
            id="mas2casos"
            name="cantidad-ataques"
            v-validate="'required'"
            value="Más de 2 casos/eventos"
          >
          <label class="form__label" for="mas2casos">
            <span>Más de 2 casos/eventos</span>
          </label>
        </div>
      </form-group>

      <form-group :error="errors.has('detalles-ataques') && submitted">
        <textarea
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.detallesAtaques"
          name="detalles-ataques"
          required
          v-validate="'required'"
        />
        <label class="form__label">
          Detalles
        </label>
      </form-group>
    </div>

    <form-group :error="errors.has('mejoras') && submitted">
      <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.mejoras"
        name="mejoras"
        required
        v-validate="'required'"
      >
      <label class="form__label">
        9. ¿Encontró diferencias o mejoras con respecto a la visita anterior
         , tomando en cuenta los comentarios o sugerencias brindadas
         , o acuerdos tomados?
      </label>
    </form-group>

    <form-group
      :error="errors.has('estrategia-antidepredatoria') && submitted">
      <label class="form__label form__label--required">
        10. Se inició con la implementación de alguna estrategia anti-depredatoria?
      </label>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.estrategiaAntidepredatoria"
          id="si-uacfel"
          name="estrategia-antidepredatoria"
          v-validate="'required'"
          value="Si, con el apoyo económico parcial o total de UACFel (en materiales)"
        >
        <label class="form__label" for="si-uacfel">
          Si, con el apoyo económico parcial o total de UACFel (en materiales)
        </label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.estrategiaAntidepredatoria"
          id="si-ganadero"
          name="estrategia-antidepredatoria"
          v-validate="'required'"
          value="Si, pero el ganadero está cubriendo la totalidad del costo"
        >
        <label class="form__label" for="si-ganadero">
          Si, pero el ganadero está cubriendo la totalidad del costo
        </label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.estrategiaAntidepredatoria"
          id="no-nada"
          name="estrategia-antidepredatoria"
          v-validate="'required'"
          value="No, no se está implementando nada"
        >
        <label class="form__label" for="no-nada">
          No, no se está implementando nada
        </label>
      </div>
    </form-group>

    <form-group
      v-if="respuestaEstrategia('Si')"
      :error="errors.has('porcentaje-avance') && submitted"
      class="identado"
    >
      <label class="form__label form__label--required">
        10.1. Esta tiene un avance del
      </label>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.porcentajeAvance"
          id="0x100"
          name="porcentaje-avance"
          v-validate="'required'"
          value="0%"
        >
        <label class="form__label" for="0x100">0%</label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.porcentajeAvance"
          id="25x100"
          name="porcentaje-avance"
          v-validate="'required'"
          value="25%"
        >
        <label class="form__label" for="25x100">25%</label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.porcentajeAvance"
          id="50x100"
          name="porcentaje-avance"
          v-validate="'required'"
          value="50%"
        >
        <label class="form__label" for="50x100">50%</label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.porcentajeAvance"
          id="75x100"
          name="porcentaje-avance"
          v-validate="'required'"
          value="75%"
        >
        <label class="form__label" for="75x100">75%</label>
      </div>
      <div class="radio radio--azul">
        <input
          :disabled="!editando"
          type="radio"
          v-model="form.porcentajeAvance"
          id="100x100"
          name="porcentaje-avance"
          v-validate="'required'"
          value="100%"
        >
        <label class="form__label" for="100x100">100%</label>
      </div>
    </form-group>

    <form-group
      v-if="respuestaEstrategia('No')"
      :error="errors.has('motivo-nada') && submitted"
      class="identado"
    >
      <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.motivoNoImplementacion"
        name="motivo-nada"
        required
        v-validate="'required'"
      >
      <label class="form__label">
        10.1. Debido a
      </label>
    </form-group>
  </form>
</template>

<script>
export default {
  methods: {
    respuestaEstrategia(val) {
      return this.form.estrategiaAntidepredatoria
      && this.form.estrategiaAntidepredatoria.substr(0, 2) === val;
    },
  },
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
};
</script>
